<template>
  <Toast />

  <DataTable
    ref="dv"
    id="id_bitacora"
    dataKey="id_bitacora"
    :value="bitacoras"
    :paginator="true"
    :rows="15"
    :loading="loading1"
    :filters="filters"
    showGridlines
    scrollable
    removableSort 
    scrollHeight="400px"
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    :rowsPerPageOptions="[15, 20, 30, 40, 50]"
    currentPageReportTemplate="Viendo {first} a {last} de {totalRecords} bitácoras"
  >
    <template #header>
      <div
        class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
      >
        <span class="p-input-icon-left">
          <!-- <div class="p-inputgroup">
                  <InputText placeholder="Keyword" /><Button label="Search" />
                </div> -->

          <i class="pi pi-search" />
          <InputText
            v-model="filters['global'].value"
            placeholder="Buscar..."
            size="75"
          /><Button
            type="button"
            icon="pi pi-filter-slash"
            class="p-button-outlined"
            @click="initFilters()"
          />
        </span>
      </div>
    </template>
    <template #empty><b>No se encontró ningún bitácora.</b></template>
    <template #loading> Cargando Bitácoras... </template>

    <Column
      field="id_viaje"
      header="ID Viaje"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="id_bitacora"
      header="ID Bitácora"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="fecha_ingresado"
      header="Fecha Ingresado"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="fecha"
      header="Fecha"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="localidad"
      header="Localidad"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="camion"
      header="Camion"
      sortable
      
      :autoWidth="true"
    ></Column>
    <Column
      field="kminicial"
      header="Km Inicial"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="kmfinal"
      header="Km Final"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="kmrecorrido"
      header="Km Recorridos"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="tipoenvio"
      header="Tipo de Envio"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="documentosap"
      header="Documento SAP"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="cliente"
      header="Cliente"
      sortable
      
      :autoWidth="true"
      style="
        min-width: 22rem;
        white-space: normal;
        word-wrap: break-word;
        text-align: left;
      "
    ></Column>
    <Column
      field="usuario"
      header="Usuario"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="piloto"
      header="Piloto"
      sortable
      
      :autoWidth="true"
      style="
        min-width: 22rem;
        white-space: normal;
        word-wrap: break-word;
        text-align: left;
      "
    ></Column>
    <Column
      field="viajesextra"
      header="Viajes Extras"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="pesosap"
      header="Pesoap"
      sortable
      
      :autoWidth="true"
      style="min-width: 12rem; white-space: nowrap"
    ></Column>
    <Column
      field="ayudante"
      header="Ayudante #1"
      sortable
      
      :autoWidth="true"
      style="
        min-width: 22rem;
        white-space: normal;
        word-wrap: break-word;
        text-align: left;
      "
    ></Column>
    <Column
      field="ayudante2"
      header="Ayudante #2"
      sortable
      
      :autoWidth="true"
      style="
        min-width: 22rem;
        white-space: normal;
        word-wrap: break-word;
        text-align: left;
      "
    ></Column>
    <Column :exportable="false" style="min-width: 12rem; white-space: nowrap">
      <template #body="slotProps">
        <Button
          icon="pi pi-map"
          class="p-button-rounded p-button-success p-mr-2"
          @click="updateLink(slotProps.data)"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
export default {
  data() {
    return {
      filters: null,
      loading1: true,
      isLoading: false,
      bitacoras: null,
    };
  },
  created() {
    this.initFilters();
    this.loadBitacoras();
  },

  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.EQUALS },
      };
    },
    
    updateLink(product) {
      console.log(product);
      const redirectUrl = 'https://www.google.com/maps?q=' + product.bdsap;
      console.log(redirectUrl);

      // Abrir el enlace en una nueva pestaña
      window.open(redirectUrl, '_blank');
    },

    async loadBitacoras() {
      try {
        this.bitacoras = await this.$store.dispatch('loadBitacoras');
        console.log(this.bitacoras);
        this.loading1 = false;
      } catch (error) {
        this.error = error.message || 'algo salió mal';
        this.loading1 = false;
      }
    },
  },
};
</script>
<style scoped>
.p-datatable-scrollable-header {
  position: sticky !important;
  top: 0;
  z-index: 100;
  background: white;
}
</style>
